const responseStatus = {
	success: 0,
	error: 1,
	warning: 2
};

export { responseStatus };
